export default __webpack_public_path__ + "static/media/buyer.71c581eb.svg";